import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'
import Rowbox from '../Common/Rowbox'
import { DECORATION_MERCHANT_NEW_UPDATES } from '@constant'
import Store from './store'
import Title from './Title'
import List from './List'

@inject('decorationStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store(props.decorationStore)
  }

  componentDidMount() {
    this.store.getMerchantUpdates()
  }

  render() {
    const {
      decorationStore: { newThemeConfig }
    } = this.props
    const { tabBg, tabSelectedBg, shopInfoBoxBg } = newThemeConfig
    console.log('tabBg: ', tabBg)
    console.log('tabSelectedBg: ', tabSelectedBg)

    const { showMerchantUpdates, updates } = this.store

    return showMerchantUpdates ? (
      <Rowbox
        type={DECORATION_MERCHANT_NEW_UPDATES}
        store={this.props.decorationStore}
        style={{
          height: 'auto',
          flexDirection: 'column',
          backgroundColor: shopInfoBoxBg,
          padding: '0'
        }}
        vCenter={false}
      >
        <Title theme={newThemeConfig} />
        <List theme={newThemeConfig} list={toJS(updates.list)} />
      </Rowbox>
    ) : null
  }
}
